module.exports = __webpack_public_path__ + "img/attachment.d729430f.svg";